
import DOMPurify from 'dompurify';

export function Sanitizer(html) {
  return DOMPurify.sanitize(html);
}